module.exports = "/virtual-football-league/img/amblems/right/France/Fake_Lille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/France/Fake_Lille.png
// module id = 2134
// module chunks = 4